// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Nr","poster":"e_Or","player":"e_Pr","play":"e_Qr","playBadge":"e_Rr","playIcon":"e_Sr","loading":"e_Tr","spin":"e_Ur"};